
<template>
  <div class="terminal-modal">
    <!-- MODAL -->
      <div class="terminal-box animated fadeIn">
        <i class="fas fa-times"></i>
        <h2>{{items.activity.terminal.title}}</h2>
        <p v-html="items.activity.terminal.text"></p>
        <button class="button back" @click="tryAgain">{{items.activity.terminal.button}}</button>
      </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    tryAgain() {
      this.$emit("tryAgain");
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  components: {},
  props: []
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// TerminalModal.vue?2f544a12